import { RuleProps } from 'types/application';
import { CORRESPONDENCE_DETAILS } from './contactDetails';

export const SECT_ORGANISATION = 'organisation';
export const SECT_TYPE = 'applicant-type-section';
export const APPLICANT_CONTACT = 'applicant-contact';
export const SECT_APPLICANT = 'applicant-details';

const contactPersonFields = [
    { id: 'name', label: 'Name', type: 'text' },
    { id: 'designation', label: 'Designation', type: 'text' },
    { id: 'email', label: 'Email', type: 'text' },
    { id: 'telNumber', label: 'Office Tel Number', type: 'text' },
    { id: 'mobileNo', label: 'Mobile Number', type: 'text' }
];

export const LICENCE_ORGANISATION = [
    {
        sectionID: SECT_TYPE,
        sectionName: '',
        fieldList: [
            {
                id: 'applicant-type',
                label: 'I am applying:',
                type: 'text',
                row: true,
                span: 12,
                defaultValue: 'Applicant',
                options: [
                    {
                        optID: 'Applicant',
                        optLabel: 'As an Applicant'
                    },
                    {
                        optID: 'Filer',
                        optLabel: 'On behalf of an Applicant'
                    }
                ]
            }
        ]
    },
    {
        sectionID: SECT_ORGANISATION,
        sectionName: 'Applicant Details',
        fieldList: [
            {
                id: 'licenceName',
                label: 'Licence Name',
                type: 'text',
                rule: {
                    hidden: true
                }
            },
            {
                id: 'salutation',
                label: 'Salutation',
                type: 'text'
            },
            {
                id: 'name',
                label: 'Name',
                type: 'text'
            },
            {
                id: 'idType',
                label: 'ID Type',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-idType`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'idNumber',
                label: 'ID Number',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-idNumber`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'email',
                label: 'Email Address',
                type: 'text'
            },
            {
                id: 'contactNumber',
                label: 'Contact Number',
                type: 'text'
            },
            // {
            //     id: 'dateOfBirth',
            //     label: 'Date of Birth',
            //     type: 'text',
            //     rule: {
            //         baseIds: [`${SECT_ORGANISATION}-licenceName`],
            //         hidden: ({ baseValues }: RuleProps) => {
            //             const result = Boolean(
            //                 baseValues &&
            //                     !(
            //                         baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
            //                         baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit'
            //                     )
            //             );
            //             return result;
            //         }
            //     }
            // },
            {
                id: 'nationality',
                label: 'Nationality',
                type: 'dropdown',
                apiID: 'Nationality',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-nationality`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'passportNumber',
                label: 'Passport Number',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-passportNumber`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'designation',
                label: 'Designation',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                !(
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit'
                                )
                        );
                        return result;
                    }
                }
            },
            {
                id: 'telephoneNumber',
                label: 'Telephone Number',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                !(
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit'
                                )
                        );
                        return result;
                    }
                }
            },
            {
                id: 'mobileNumber',
                label: 'Mobile Number',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                !(
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit'
                                )
                        );
                        return result;
                    }
                }
            },
            {
                id: 'postal',
                label: 'Postal Code',
                type: 'postal',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-uenNo`, `${SECT_ORGANISATION}-licenceName`],
                    required: true,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-uenNo`] !== '' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'block-house',
                label: 'Block/House No.',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-uenNo`, `${SECT_ORGANISATION}-licenceName`],
                    required: true,
                    charLength: 10,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-uenNo`] !== '' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'street',
                label: 'Street Name',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-uenNo`, `${SECT_ORGANISATION}-licenceName`],
                    required: true,
                    charLength: 32,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-uenNo`] !== '' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'building',
                label: 'Building Name',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-uenNo`, `${SECT_ORGANISATION}-licenceName`],
                    charLength: 66,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-uenNo`] !== '' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'floor',
                label: 'Floor No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: 01, B1, 01M',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-uenNo`, `${SECT_ORGANISATION}-licenceName`],
                    charLength: 3,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-uenNo`] !== '' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'unit',
                label: 'Unit No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: #05-01, use 01',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-uenNo`, `${SECT_ORGANISATION}-licenceName`],
                    charLength: 5,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-uenNo`] !== '' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: SECT_ORGANISATION,
        sectionName: 'Applicant Residential Address',
        rule: {
            baseIds: [`${SECT_ORGANISATION}-app-applicant-residential-address`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(
                    baseValues &&
                        (baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                            baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit' ||
                            baseValues[`${SECT_ORGANISATION}-licenceName`] ===
                                'Exhibition of Telecommunication Equipment (without Frequency)' ||
                            baseValues[`${SECT_ORGANISATION}-licenceName`] ===
                                'Exhibition of Telecommunication Equipment (with Frequency)' ||
                            baseValues[`${SECT_ORGANISATION}-licenceName`] === 'TV Receive-Only System Licence' ||
                            baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Film (Distribution/Exhibition) Licence' ||
                            baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Telecommunication Wiring Contractor Class Licence' ||
                        baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Registration for Internet Access Service Providers And Resellers Class Licence' )
                );
                return result;
            }
        },
        fieldList: [
            {
                id: 'postal',
                label: 'Postal Code',
                type: 'postal',
                span: 12
            },
            {
                id: 'block-house',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'street',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'floor',
                label: 'Floor/Level (Optional)',
                type: 'text',
                placeholder: 'Eg: 01, B1, 01M'
            },
            {
                id: 'unit',
                label: 'Unit (Optional)',
                type: 'text',
                placeholder: 'Eg: #05-01, use 01'
            },
            {
                id: 'building',
                label: 'Building Name',
                type: 'text'
            }
        ]
    },
    {
        sectionID: SECT_ORGANISATION,
        sectionName: 'Filer Details',
        fieldList: [
            {
                id: 'filerSalutation',
                label: 'Salutation',
                type: 'text'
            },
            {
                id: 'filerName',
                label: 'Name',
                type: 'text'
            },
            {
                id: 'filerIDType',
                label: 'ID Type',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-idType`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'filerIDNumber',
                label: 'ID Number',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-filerIDNumber`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'filerEmail',
                label: 'Email Address',
                type: 'text'
            },
            {
                id: 'filerContactNumber',
                label: 'Contact Number',
                type: 'text'
            },
            {
                id: 'filerMobileNumber',
                label: 'Mobile Number',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                !(
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit'
                                )
                        );
                        return result;
                    }
                }
            },
            {
                id: 'filerPostal',
                label: 'Postal Code',
                type: 'postal',
                rule: {
                    required: true,
                    baseIds: [`${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'filer-block-house',
                label: 'Block/House No.',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'filer-street',
                label: 'Street Name',
                type: 'text',
                rule: {
                    required: true,
                    charLength: 32,
                    baseIds: [`${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'filer-building',
                label: 'Building Name',
                type: 'text',
                rule: {
                    charLength: 66,
                    baseIds: [`${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'filer-floor',
                label: 'Floor No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: 01, B1, 01M',
                rule: {
                    charLength: 3,
                    baseIds: [`${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'filer-unit',
                label: 'Unit No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: #05-01, use 01',
                rule: {
                    charLength: 5,
                    baseIds: [`${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            }
        ],
        rule: {
            baseIds: [`${SECT_TYPE}-applicant-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const valuesToCheck = [
                    `${SECT_ORGANISATION}-filerSalutation`,
                    `${SECT_ORGANISATION}-filerName`,
                    `${SECT_ORGANISATION}-filerIDType`,
                    `${SECT_ORGANISATION}-filerIDNumber`,
                    `${SECT_ORGANISATION}-filerEmail`,
                    `${SECT_ORGANISATION}-filerContactNumber`,
                    `${SECT_ORGANISATION}-filerMobileNumber`,
                    `${SECT_ORGANISATION}-filerPostal`,
                    `${SECT_ORGANISATION}-filer-block-house`,
                    `${SECT_ORGANISATION}-filer-street`,
                    `${SECT_ORGANISATION}-filer-building`,
                    `${SECT_ORGANISATION}-filer-floor`,
                    `${SECT_ORGANISATION}-filer-unit`
                ];
                const result = Boolean(
                    (baseValues && baseValues[`${SECT_TYPE}-applicant-type`] === 'Applicant') ||
                        (baseValues && valuesToCheck.every((key) => baseValues[key] === '-'))
                );
                return result;
            }
        }
    },
    {
        sectionID: SECT_ORGANISATION,
        sectionName: 'Company Details',
        fieldList: [
            {
                id: 'companyName',
                label: 'Name of Company',
                type: 'text'
            },
            {
                id: 'uenNo',
                label: 'UEN',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                !(
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit'
                                )
                        );
                        return result;
                    }
                }
            },
            {
                id: 'entityType',
                label: 'Company Type',
                type: 'dropdown',
                apiID: 'CommonData',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'entityType',
                label: 'Entity Type',
                type: 'dropdown',
                apiID: 'CommonData',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                !(
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit'
                                )
                        );
                        return result;
                    }
                }
            },
            {
                id: 'address-type',
                label: 'Address Type',
                type: 'text',
                span: 12
            },
            {
                id: 'companyPostal',
                label: 'Postal Code',
                type: 'postal',
                rule: {
                    required: true,
                    baseIds: [`${SECT_ORGANISATION}-address-type`, `${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-address-type`] === 'Foreign' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'company-block-house',
                label: 'Block/House No.',
                type: 'text',
                rule: {
                    required: true,
                    baseIds: [`${SECT_ORGANISATION}-address-type`, `${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-address-type`] === 'Foreign' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'company-street',
                label: 'Street Name',
                type: 'text',
                rule: {
                    required: true,
                    charLength: 32,
                    baseIds: [`${SECT_ORGANISATION}-address-type`, `${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-address-type`] === 'Foreign' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'company-building',
                label: 'Building Name',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-address-type`, `${SECT_ORGANISATION}-licenceName`],
                    charLength: 66,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-address-type`] === 'Foreign' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'company-floor',
                label: 'Floor No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: 01, B1, 01M',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-address-type`, `${SECT_ORGANISATION}-licenceName`],
                    charLength: 3,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-address-type`] === 'Foreign' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            {
                id: 'company-unit',
                label: 'Unit No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: #05-01, use 01',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-address-type`, `${SECT_ORGANISATION}-licenceName`],
                    charLength: 5,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                (baseValues[`${SECT_ORGANISATION}-address-type`] === 'Foreign' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence' ||
                                    baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        );
                        return result;
                    }
                }
            },
            // Foreign address fields
            {
                id: 'foreign-address-line-one',
                label: 'Foreign Address Line 1',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-address-type`, `${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const addressType = baseValues?.[`${SECT_ORGANISATION}-address-type`];
                        const licenceName = baseValues?.[`${SECT_ORGANISATION}-licenceName`];
                        const result = Boolean(
                            addressType === 'Singapore' ||
                                addressType === '' ||
                                addressType === null ||
                                licenceName === 'Printing Press Licence' ||
                                licenceName === 'Newspaper Permit'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'foreign-address-line-two',
                label: 'Foreign Address Line 2',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-address-type`, `${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const addressType = baseValues?.[`${SECT_ORGANISATION}-address-type`];
                        const licenceName = baseValues?.[`${SECT_ORGANISATION}-licenceName`];
                        const result = Boolean(
                            addressType === 'Singapore' ||
                                addressType === '' ||
                                addressType === null ||
                                licenceName === 'Printing Press Licence' ||
                                licenceName === 'Newspaper Permit'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'foreign-address-line-three',
                label: 'Foreign Address Line 3',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-address-type`, `${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const addressType = baseValues?.[`${SECT_ORGANISATION}-address-type`];
                        const licenceName = baseValues?.[`${SECT_ORGANISATION}-licenceName`];
                        const result = Boolean(
                            addressType === 'Singapore' ||
                                addressType === '' ||
                                addressType === null ||
                                licenceName === 'Printing Press Licence' ||
                                licenceName === 'Newspaper Permit'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'city',
                label: 'City',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-address-type`, `${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const addressType = baseValues?.[`${SECT_ORGANISATION}-address-type`];
                        const licenceName = baseValues?.[`${SECT_ORGANISATION}-licenceName`];
                        const result = Boolean(
                            addressType === 'Singapore' ||
                                addressType === '' ||
                                addressType === null ||
                                licenceName === 'Printing Press Licence' ||
                                licenceName === 'Newspaper Permit'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'state',
                label: 'State',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-address-type`, `${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const addressType = baseValues?.[`${SECT_ORGANISATION}-address-type`];
                        const licenceName = baseValues?.[`${SECT_ORGANISATION}-licenceName`];
                        const result = Boolean(
                            addressType === 'Singapore' ||
                                addressType === '' ||
                                addressType === null ||
                                licenceName === 'Printing Press Licence' ||
                                licenceName === 'Newspaper Permit'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'zip-code',
                label: 'Zip Code',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-address-type`, `${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const addressType = baseValues?.[`${SECT_ORGANISATION}-address-type`];
                        const licenceName = baseValues?.[`${SECT_ORGANISATION}-licenceName`];
                        const result = Boolean(
                            addressType === 'Singapore' ||
                                addressType === '' ||
                                addressType === null ||
                                licenceName === 'Printing Press Licence' ||
                                licenceName === 'Newspaper Permit'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'country',
                label: 'Country',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-address-type`, `${SECT_ORGANISATION}-licenceName`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const addressType = baseValues?.[`${SECT_ORGANISATION}-address-type`];
                        const licenceName = baseValues?.[`${SECT_ORGANISATION}-licenceName`];
                        const result = Boolean(
                            addressType === 'Singapore' ||
                                addressType === '' ||
                                addressType === null ||
                                licenceName === 'Printing Press Licence' ||
                                licenceName === 'Newspaper Permit'
                        );
                        return result;
                    }
                }
            }
        ],
        rule: {
            baseIds: [`${SECT_ORGANISATION}-companyName`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(baseValues && baseValues[`${SECT_ORGANISATION}-companyName`]);
                return !result;
            }
        }
    },
    {
        sectionID: SECT_ORGANISATION,
        sectionName: 'Company Address',
        fieldList: [
            {
                id: 'address-type',
                mainLabel: 'Office Address',
                label: 'Address Type',
                type: 'text',
                span: 12
            },
            {
                id: 'foreign-address-line-one',
                label: 'Address Line 1',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-foreign-address-line-one`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_ORGANISATION}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'foreign-address-line-two',
                label: 'Address Line 2',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-foreign-address-line-two`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_ORGANISATION}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'foreign-address-line-three',
                label: 'Address Line 3',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-foreign-address-line-three`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_ORGANISATION}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'country',
                label: 'Country',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-country`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_ORGANISATION}-address-type`] === 'Local');
                        return result;
                    }
                }
            },
            {
                id: 'companyPostal',
                label: 'Postal Code',
                type: 'postal',
                span: 12,
                rule: {
                    required: true,
                    baseIds: [`${SECT_ORGANISATION}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_ORGANISATION}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'company-block-house',
                label: 'Block/House No.',
                type: 'text',
                rule: {
                    required: true,
                    baseIds: [`${SECT_ORGANISATION}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_ORGANISATION}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'company-street',
                label: 'Street Name',
                type: 'text',
                rule: {
                    required: true,
                    charLength: 32,
                    baseIds: [`${SECT_ORGANISATION}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_ORGANISATION}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'company-floor',
                label: 'Floor/Level (Optional)',
                type: 'text',
                placeholder: 'Eg: 01, B1, 01M',
                rule: {
                    charLength: 3,
                    baseIds: [`${SECT_ORGANISATION}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_ORGANISATION}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'company-unit',
                label: 'Unit (Optional)',
                type: 'text',
                placeholder: 'Eg: #05-01, use 01',
                rule: {
                    charLength: 5,
                    baseIds: [`${SECT_ORGANISATION}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_ORGANISATION}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'company-building',
                label: 'Building Name',
                type: 'text',
                rule: {
                    charLength: 66,
                    baseIds: [`${SECT_ORGANISATION}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SECT_ORGANISATION}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            }
        ],
        rule: {
            baseIds: [`${SECT_ORGANISATION}-licenceName`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(
                    baseValues &&
                        !(
                            (baseValues[`${SECT_ORGANISATION}-uenNo`] !== '' &&
                                baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Printing Press Licence') ||
                            (baseValues[`${SECT_ORGANISATION}-uenNo`] !== '' &&
                                baseValues[`${SECT_ORGANISATION}-licenceName`] === 'Newspaper Permit')
                        )
                );
                return result;
            }
        }
    },
    {
        sectionID: APPLICANT_CONTACT,
        sectionName: 'Contact Person Particulars',
        rule: {
            hidden: () => {
                const licenceName = sessionStorage.getItem('licenceName');

                if (!licenceName) {
                    return true;
                }

                if (
                    licenceName === 'Telecommunication Dealer’s (Individual) Licence' ||
                    licenceName === 'Telecommunication Dealer’s (Class) Licence'
                ) {
                    return false; // Show if the specific licenceName is present
                }

                return true;
            }
        },
        fieldList: contactPersonFields
    },
    {
        sectionID: `${APPLICANT_CONTACT}-person-table`,
        sectionName: 'Contact Person Particulars',
        rule: {
            baseIds: [`${APPLICANT_CONTACT}-person-table`],
            hidden: ({ baseValues }: RuleProps) => {
                const list = baseValues?.['applicant-contact-person-table-list'];
                const shouldShow = Array.isArray(list) && list.length > 0;
                return !shouldShow;
            }
        },
        fieldList: [
            {
                id: 'applicant-contact-person-table',
                label: '',
                type: 'table2',
                subFields: [
                    {
                        id: 'Salutation',
                        header: 'Salutation',
                        type: 'text'
                    },
                    {
                        id: 'name',
                        header: 'Name',
                        type: 'text'
                    },
                    {
                        id: 'designation',
                        header: 'Designation',
                        type: 'text'
                    },
                    {
                        id: 'idType',
                        header: 'ID Type',
                        type: 'text'
                    },
                    {
                        id: 'email',
                        header: 'Email address',
                        type: 'text'
                    },
                    {
                        id: 'ContactNumber',
                        header: 'Contact Number',
                        type: 'text'
                    },
                    {
                        id: 'notifyViaSmsForFutureLicenceRenewal',
                        header: 'Notify via SMS for future licence renewal',
                        type: 'text'
                    }
                ],
                span: 12
            }
        ]
    },
    {
        sectionID: CORRESPONDENCE_DETAILS,
        sectionName: 'Contact Person Address',
        rule: {
            hidden: () => {
                const licenceName = sessionStorage.getItem('licenceName');

                if (!licenceName) {
                    return true;
                }

                if (
                    licenceName === 'Telecommunication Dealer’s (Individual) Licence' ||
                    licenceName === 'Telecommunication Dealer’s (Class) Licence'
                ) {
                    return false; // Show if the specific licenceName is present
                }

                return true;
            }
        },
        fieldList: [
            {
                id: 'buildingName',
                label: 'Building Name',
                type: 'text'
            },
            {
                id: 'postalCode',
                label: 'Postal Code',
                type: 'postal'
            },
            {
                id: 'streetName',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'blockNo',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'floor',
                label: 'Floor No.',
                type: 'text'
            },
            {
                id: 'unit',
                label: 'Unit No.',
                type: 'text'
            }
        ]
    }
];
